import { AppBar, Stack, Toolbar, Typography } from "@mui/material";
import { DicomGridController } from "../dicom-grid-controller/DicomGridController";
import { DicomDownload } from "../dicom-download/DicomDownload";
import { DicomViewerHelpDialog } from "../dicom-viewer-help/DicomViewerHelp";
import { XcaliberControls } from "pages/viewer/tools/miscellaneous-tools/xcaliber-tool/XcaliberControls";
import { Documents } from "pages/home-page/components/study-table/study-table-rows/components/documents/Documents";
import { useViewerContext } from "pages/viewer/context/viewer.context";
import { useAppContext } from "context/app.context";
import { getStudyByPk } from "services/studies/studies";
import { useEffect, useState } from "react";
import { snakeToCamelCase } from "utils/networking/snakeToCamelCase";
import { StudyData } from "pages/home-page/components/study-table/studyTable.types";
import { USER_TYPES } from "consts";

export const ViewerHeaderBar = () => {

  const {
    state: { studyImageData },
  } = useViewerContext();
  const {
    state: { userId, userType, isLoggedIn, isDarkModeOn },
  } = useAppContext();

  const allowedReportUsers = [
    USER_TYPES.RADIOLOGIST, 
    USER_TYPES.CHIRO_MEDICARE, 
    USER_TYPES.ADMIN, 
    USER_TYPES.MEDICARE_ADMIN, 
    USER_TYPES.DEVELOPER
  ];
  const isReportUserType = allowedReportUsers.includes(userType);
  const studyPk = studyImageData?.[0]?.studyPk;
  const studyIuid = studyImageData?.[0]?.studyIuid;
  const [studyData, setStudyData] = useState(null);

  useEffect(() => {
  const fetchStudyData = async () => {
    if (studyPk) {
      try {
        const result = await getStudyByPk(studyPk);
        if (Array.isArray(result) && result.length > 0) {
          const study = result[0];

          const formattedStudy = snakeToCamelCase(
            study
          ) as unknown as StudyData;

          const formattedStudyWithUserId = {
            ...formattedStudy,
            studypk: studyPk,
            userId: userId,
          };
          setStudyData(formattedStudyWithUserId);
        }
      } catch (error) {
        console.error("Error fetching study data:", error);
      }
    }
  };

  fetchStudyData();
}, [studyPk]);

  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: "#1a1a1a",
        maxHeight: "48px",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        variant="dense"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Stack direction="row" spacing={1} sx={{ position: "relative" }}>
          <Typography
            variant="h6"
            noWrap
            sx={{ flexGrow: 1, color: "white" }}
            component="div"
          >
            iTX Viewer
          </Typography>
        </Stack>
        <Typography
          id="toolInstructions"
          variant="h6"
          noWrap
          sx={{ flexGrow: 1, color: "lime", textAlign: "center" }}
          component="div"
        />
        <XcaliberControls />
        <Stack direction="row" spacing={1} sx={{ position: "relative" }}>
          {studyData && isReportUserType ? <Documents studyData={studyData} iconColourInverted={true} /> : null }
          <DicomGridController />
          <DicomDownload />
          <DicomViewerHelpDialog />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
